import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';
import { NgProgress } from 'ngx-progressbar';
import { PadraoService } from "../service/padrao.service";
import { Locale } from "../util/locale.ptbr";
import { Helpers } from '../util/helpers';
import { EventEmitterService } from 'app/util/emitter-service/emitter-service';
import { SelectItem } from 'primeng/components/common/selectitem';
import { Observable } from 'rxjs/Observable';

import { ReplaySubject } from 'rxjs';
import * as FileSaver from 'file-saver';
import { ObservableBlockPanel, ObservableLotacao, bObservableUsuario, ObservableBlockPanelDoc } from '../util/observable-util';
import { RegistroImplementation } from '../base/use-system/implementation-system/index';
import { CriarSistema } from './use-system/interface-system/system-interface';
import { CabecalhoMensagens, TipoMensagem, MensagensPadrao, Acao } from './use-system/enums/Enumarations';
import { MessageService } from 'primeng/components/common/messageservice';
import { CurrencyPipe } from '@angular/common';

import { EVENT_MSGS_UPDATE } from './../util/emitter-service/nome-evento';


@Component({ template: '', providers: [MessageService] })
export class BaseComponent implements OnInit {
    controllerName: string = '';
    contentCheck: number = 0;

    perfilLotado: any;
    msgs: Message[] = [];
    reader = new FileReader();

    dataRange;
    /**
     * Data atual.
     */
    today = Date.now();
    yearRange = new Date();
    /**
     * Ano anterior.
     */
    lastYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1));

    /*
    * Validações para utilizar componente de edição nas grids das etapas de PF e PJ 
    */
    labelBtn: string = "Adicionar";
    labelIcon: string = "ui-icon-plus";
    isEdit: boolean = false;
    disableButton: boolean = false;
    msgTooltipEditar: string = "Editar";
    msgTooltipExcluir: string = "Excluir";

    constructor(
        public formBuilder: FormBuilder,
        public ngProgress: NgProgress,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public service: PadraoService,
        public confirmacao: ConfirmationService,
        public locale: Locale,
        public help: Helpers,
        public observableUtilPanel: ObservableBlockPanel,
        public observableUtilPanelDoc: ObservableBlockPanelDoc,
        public observableUtilLotacao: ObservableLotacao,
        public observableUser: bObservableUsuario,
        public currencyPipe: CurrencyPipe
    ) { }
    /**
     * Instancia do sistema a ser usado para validar as enums e realizar a funções especificas para a datatable de cada sistema
     */
    sistema = CriarSistema(RegistroImplementation, this.router, this.activatedRoute, this.service, this.confirmacao, this.msgs, this.observableUser, this.observableUtilPanelDoc);
    /**
     * Primeiro método a ser carregado na inicialização dos componentes. Deve ser implementado nas classes filhas.
     * @param optional1 parametro opcional a ser pedido na classe filha
     * @param optional2 parametro opcional a ser pedido na classe filha
     */
    init(optional1?: any, optional2?: any) {
        if (sessionStorage.getItem("msg") !== null) {
            this.showMsg(TipoMensagem[1], CabecalhoMensagens[2], sessionStorage.getItem("msg"))
        }
        sessionStorage.removeItem("msg");
    };
    /**
     * Segundo método a ser carregado na inicialização dos componentes. Deve ser implementado nas classes filhas.
     * @param optional1 parametro opcional a ser pedido na classe filha
     * @param optional2 parametro opcional a ser pedido na classe filha
     */
    afterInit(optional1?: any, optional2?: any) { };
    /**
     * Terceiro método a ser carregado na inicialização dos componentes. Deve ser implementado nas classes filhas.
     * @param optional1 parametro opcional a ser pedido na classe filha
     * @param optional2 parametro opcional a ser pedido na classe filha
     */
    afterLoad(optional1?: any, optional2?: any) { };
    /**
     * Metodo a ser definido na classe filha, usado na multi validação.
     * @param isInit variavel optional usada para validar a ação na inicialização
     */
    emitValidation(isInit?: any) { };
    /**
     * Metodo a ser adicionado em funções que precisam realizar ações específicas sem alterar a estrtura generica
     * do método. Deve ser adicionado no método desejado e implementado na classe filha que será necessário realizar
     * a validação.
     */
    undefinedMethod() { };
    ngOnInit() {
        this.init();
        this.afterInit();
        this.afterLoad();
    }

    /**
     * Retorna um objeto a partir dos dados passados, usando o filter para realizar a comparação do dado.
     * @param arr array usado para obter o item desejado
     * @param filter objeto usado para comparação dos dados
     */
    getItemBy(arr: any, filter: any) {
        if (arr == null)
            return "";
        let ret = arr.find(item => {
            let select = true;
            Object.keys(filter).forEach(fkey => {
                if (select && item[fkey] != filter[fkey])
                    select = false;
            });
            return select;
        });
        return ret ? ret : "";
    }

    listItemBy(arr: any, filter: any) {
        if (arr == null)
            return [];
        let ret = arr.filter(item => {
            let select = true;
            Object.keys(filter).forEach(fkey => {
                if (select && item[fkey] != filter[fkey])
                    select = false;
            });
            return select;
        });
        return ret ? ret : [];
    }

    showMsg(severity: string, summary: string, detail: string) {
        this.msgs = [];
        this.msgs.push({ severity: severity, summary: summary, detail: detail });
        setTimeout(() => {
            this.msgs = [];
        }, 5000);
        EventEmitterService.get(EVENT_MSGS_UPDATE).emit(this.msgs);
    }

    showMsgError(mensagem: string) {
        this.showMsg(TipoMensagem[4], CabecalhoMensagens[4], mensagem);
    }

    showMsgWarn(mensagem: string) {
        this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], mensagem);
    }

    showMsgInfo(mensagem: string) {
        this.showMsg(TipoMensagem[2], CabecalhoMensagens[5], mensagem);
    }

    showMsgSucess(mensagem: string) {
        this.showMsg(TipoMensagem[1], CabecalhoMensagens[1], mensagem);
    }

    touchAll(formGroup: FormGroup | FormArray, func = 'markAsDirty', opts = { onlySelf: false }): void {
        Object.keys(formGroup.controls).map((key, index) => {
            let obj = formGroup.controls[key];
            if (obj instanceof FormGroup || obj instanceof FormArray)
                this.touchAll(obj, func, opts);
            else
                obj[func](opts);
        });
    }

    touchEspecifico(formGroup: any, property: any, func = 'markAsDirty', opts = { onlySelf: false }): void {
        Object.keys(formGroup.controls).map((key, index) => {
            if (key == property) {
                let obj = formGroup.controls[key];
                obj.setValue(null);
                if (obj instanceof FormGroup || obj instanceof FormArray)
                    this.touchAll(obj, func, opts);
                else
                    obj[func](opts);
            }
        });
    }

    /**
     * Seta todos os campos da variavél formGroup com o validador passado.
     * @param formGroup Formulario ou Array de Formularios a ser setado o validador passado
     * @param validator Validador a ser setado no Form passado.
     */
    setValidators(formGroup: FormGroup | FormArray, validator: any): void {
        Object.keys(formGroup.controls).map((key, index) => {
            let obj = formGroup.controls[key];
            if (obj instanceof FormGroup || obj instanceof FormArray)
                this.setValidators(obj, validator);
            else
                obj.setValidators(validator);
        });
    }

    /**
     * Verifica se o formulario passado possui controls vazias.
     * @param formGroup Formulario ou Array de Formularios a ser verificado
     * @param controlNameExcept nome do campos que não serão verificados.
     */
    verifyControlsEmpty(formGroup: FormGroup | FormArray, controlNameExcept?: string): boolean {
        let count: number = 0;
        Object.keys(formGroup.controls).map((key, index) => {
            const obj = formGroup.controls[key];
            if ((obj.value === undefined || obj.value === null || obj.value === '') && controlNameExcept !== key) {
                count++;
            }
        });
        if (count > 0) return false;
        else return true;
    }

    /**
     * Verifica se a lista possui o objeto passado pelo usuário. 
     * @param list lista a ser validade
     * @param obj objeto usado para comparação de dados na lista
     */
    validateListExists(list: any, obj: any) {
        if (this.getItemBy(list, obj) != "") {
            this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], MensagensPadrao[7])
            return true;
        } else {
            return false;
        }
    }

    /**
     * Metodo que valida um array da atributos, caso verdadeiro retorna true. Pode ser sobrescrito na classe filha mas seguindo o mesmo padrão discutido aqui
     * @param listaNomeAtibutos Lista dos nomes de atributos a serem validados
     * @param lista Lista onde deve ser comparado os dados
     * @param form Formulario de comparação
     * @param errMessage Mensagem a ser exibida
     * @param hasData Caso verdadeiro a comparação verifica se o dado existe na lista, caso false verifica se o dado não existe na lista.
     */
    validateDataList(listaNomeAtibutos: string[] = null, lista: any[], form: any, errMessage: string, hasData: boolean = true): any {
        if (listaNomeAtibutos != null) {
            let result = [];
            listaNomeAtibutos.forEach(attrName => {
                let value = form instanceof FormGroup ? form.controls[attrName].value ? form.controls[attrName].value : undefined : form[attrName];
                if (value != null) {
                    if (hasData)
                        result.push(lista.find(obj => obj[attrName] == value) !== undefined ? true : false);
                    else result.push(lista.find(obj => obj[attrName] == value) === undefined ? true : false);
                } else result.push(false);
            });
            if (result.find(x => x == true) !== undefined) {
                this.showMsgError(errMessage);
                return false;
            }
            else return true;
        } else
            return true;
    };

    addToList(list: any, listEmit: EventEmitter<any>, form: FormGroup, event: any, customData: any = null, validationObj: any = null, listNameProperties?: string[], errMessage?: string) {
        if (form.valid) {
            if (validationObj != null && this.validateListExists(list, validationObj)) {
                this.disableButton = true;
                return;
            }
            if (!this.validateDataList(listNameProperties, list, form, errMessage)) {
                this.disableButton = true;
                return;
            }
            list.push(Object.assign({}, form.value, customData));
            list = [...list];
            listEmit.emit(list);
            form.reset();
            this.labelBtn = "Adicionar";
            this.labelIcon = "ui-icon-plus";
            this.disableButton = false;
            this.msgTooltipEditar = "Editar";
            this.msgTooltipExcluir = "Excluir";
            this.isEdit = false;
            this.touchAll(form, 'markAsPristine');
        } else {
            this.touchAll(form);
        }
    }

    editElementToList(list: any[], listEmit: EventEmitter<any>, index: number, form: FormGroup, isEndereco?: boolean): any {
        let dado: any;
        dado = list.splice(index, 1);
        dado.map(x => {
            if (isEndereco) {
                x.id_uf = x.cidade.uf.id
            }
            x.data_conclusao = this.dateToString(x.data_conclusao)
            x.data_colacao_grau = this.dateToString(x.data_colacao_grau)
        });
        form.patchValue(dado[0]);
        list = [...list];
        listEmit.emit(list);
        return dado[0];
    }

    dateToString(value: any): string {
        return `${new Date(value).getDate()}/${new Date(value).getMonth() + 1}/${new Date(value).getFullYear()}`;
    }

    removeFromList(list: any[], listEmit: EventEmitter<any>, index: number, message: string, minLength: number = 0, listNameProperties?: string[], form?: any, errMessage?: string, hasData?: boolean) {

        this.confirmacao.confirm({
            header: CabecalhoMensagens[1],
            message: `Atenção! Deseja mesmo remover esse item da lista ${message}?`,
            accept: () => {
                this.undefinedMethod();
                list.splice(index, 1);
                list = [...list];
                listEmit.emit(list);
                if (!this.validateDataList(listNameProperties, list, form, errMessage, hasData)) return;
                if (list.length < minLength) {
                    this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], `É necessaria a inclusão de ao menos ${minLength} ${message}`);
                    return;
                }
            }
        });
    }

    excluirRegistroLista(list: any[], listEmit: EventEmitter<any>, index: number, mensagem?: string) {
        this.confirmacao.confirm({
            header: CabecalhoMensagens[1],
            message: mensagem != null ? mensagem : 'Deseja realmente excluir esse registro?',
            accept: () => {
                this.undefinedMethod();
                list.splice(index, 1);
                list = [...list];
                listEmit.emit(list);
            }
        });
    }
    /**
     * Remove um item da lista a partir do nome passado.
     * @param lista Lista onde o item será removido
     * @param element objeto que irá ser comparado para remoção do item, deve ser identico ao item da lista onde será comparado.
     * Ex: {flg_principal: true}
     */
    removeElementByName(lista: any[], element: any): any[] {
        if (lista != null && lista.length > 0) {
            Object.keys(element).map(x => {
                const indexEmail = lista.findIndex(value => value[x] == element[x]);
                lista.splice(indexEmail, 1);
            });
            return lista;
        } else return [];
    }
    /**
     * Preenche uma lista a partir de um enumaration
     * @param enumeration enum a ser usada para preencher a lista
     */
    loadEnumAsList(enumeration: any): any {
        let half = typeof enumeration == "object" ? (Object.keys(enumeration).length * 0.5) : enumeration.length;
        return Object.keys(Object.assign({}, enumeration)).filter((key, i) => (i < half)).map((key, i, obj) => obj[key] = { value: key, label: obj[key] });
    }

    /**
     * Preenche uma lista a partir de um enum passado pelo usuario
     * @param lista lista a ser preenchida
     * @param enumeration enum a ser usada para preencher a lista
     */
    loadListAsEnum(lista: SelectItem[], enumeration: any) {
        for (var n in enumeration) {
            if (isNaN(Number(n))) {
                lista.push({ value: <any>enumeration[n], label: n });
            }
        }
    }

    loadListAsEnumTipoVisto(lista: SelectItem[], enumeration: any) {
        for (let i = 3; i <= Object.keys(enumeration).length / 2; i++) {
            lista.push({ value: i, label: enumeration[i] });
        }
    }

    /**
     * Retorna o nome de um control passado pelo usuário
     * @param c control a ser retornadp
     */
    getControlName(c: AbstractControl): string | null {
        const formGroup = c.parent.controls;
        return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
    }

    /**
     * Limpa todos os caracteres especiais da variavel passada, retorna uma string que possui caracateres alfanuméricos.
     * @param campo Variável a ser limpa
     */
    limparCaracterEspecial(campo: string): string {
        if (campo != null)
            return campo.replace(/[^0-9A-Za-z]/g, '');
        else return '';
    }

    public readFile(fileToRead: File): Observable<MSBaseReader> {
        const base64Observable = new ReplaySubject<MSBaseReader>(1);

        const fileReader = new FileReader();
        fileReader.onload = event => {
            base64Observable.next(fileReader.result);
        };
        fileReader.readAsDataURL(fileToRead);

        return base64Observable;
    }

    b64toFile(b64Data, filename, contentType) {
        var sliceSize = 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);

            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var file = new File(byteArrays, filename, { type: contentType });
        return file;
    }

    downloadFile(id: number, fileName: string, key: string, classtype: string) {
        this.service.ObterAnexo(`arquivo`, id, key, classtype).subscribe(
            data => {
                FileSaver.saveAs(this.b64toFile(data, null, "application/octet-stream"), fileName);
                this.showMsg(TipoMensagem[1], CabecalhoMensagens[2], `O arquivo '${fileName}' foi baixado automaticamente, verifique na pasta de downloads.`);
            }
            , err => this.showMsg(TipoMensagem[4], CabecalhoMensagens[4], `Houve um erro ao baixar o arquivo. ${err}`)
        );
    }

    onSelectFileUploadList(event, uploadedFiles: any[], uploadedFilesChanges: EventEmitter<any[]>, customData: any = null) {
        for (const file of event.files) {
            const nomeImg = file.name.toLowerCase();
            if (nomeImg.match(/.pdf/) || nomeImg.match(/.jpg/) || nomeImg.match(/.jpeg/) || nomeImg.match(/.png/)) {
                if (file.size < 10000000) {
                    this.observableUtilPanelDoc.setBlockedPanel(true);
                    this.readFile(file).subscribe(f => {
                        uploadedFiles.push(Object.assign({
                            nome_upload: f,
                            nome_real: file.name,
                            tamanho: file.size,
                            extensao: file.name.replace(/[\s\S]*\./g, ''),
                            id: 0
                        }, customData)
                        );
                        uploadedFiles = [...uploadedFiles];
                        uploadedFilesChanges.emit(uploadedFiles);
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    });
                }
            }
        }
    }

    /**
     * Valida se a string está vazia, nula ou indefinida. Retorna true caso alguma das opções seja verdadeira.
     * @param value string a ser validada
     */
    nullOrEmptyOrUndefined(value: string): boolean {
        if (value === 'null' || value === 'undefined' || value === '' ||
            value === null || value === undefined || value === '') return true;
        else return false;
    }

    /**
     * Verifica se uma string Value contém uma string com o valor da stringContains
     * @param value Valor a ser verificado
     * @param stringContains Valor a ser verificado
     */
    contains(value: string, stringContains: string): boolean {
        if (value.search(stringContains) == -1) return false;
        else return true;
    }

    ngAfterContentChecked() {
        if (this.contentCheck++ > 4)
            this.observableUtilPanel.setBlockedPanel(false);
    }

}


// WEBPACK FOOTER //
// ./src/app/base/base.component.ts